import { observer } from 'mobx-react';
import React, { useEffect } from 'react'
import { Form, Row } from 'react-bootstrap';
import { ActionButton, ToggleButton } from '@common/components/forms';
import { ProactivePrescriptionRuleModel, VeterinarianModel } from '@common/models';
import { useFormContext, useWatch } from 'react-hook-form';
import DataTable, { TableColumn } from 'react-data-table-component';
import { dataTableCustomStyles } from '@common/components/table';
import { useProactivePrescriptionRuleStore } from '@common/stores';
import { useNavigate } from 'react-router';

export interface IUserProactivePrescriptionsProps {
  currentOverrideHospitalProactivePrescriptions: boolean | undefined;
  isEditing: boolean;
}

export const UserProactivePrescriptions = observer(({ isEditing, currentOverrideHospitalProactivePrescriptions }: IUserProactivePrescriptionsProps) => {
  const proactiveRxStore = useProactivePrescriptionRuleStore();
  const navigate = useNavigate();

  const moveToRuleDetails = (proactiveRxRuleId: number) => navigate(`./proactivePrescriptions/${proactiveRxRuleId}`);

  useEffect(() => {
    proactiveRxStore.getProactivePrescriptionRules();
  }, [proactiveRxStore]);

  const { register, control } = useFormContext<VeterinarianModel>()
  const [optOutOfProactivePrescription, overrideHospitalProactivePrescriptions] = useWatch(
    {
      control,
      name: [
        "optOutOfProactivePrescription",
        "overrideHospitalProactivePrescriptions"
      ]
    })

  const columns: TableColumn<ProactivePrescriptionRuleModel>[] = [
    {
      name: 'Name',
      selector: row => row.name,
      grow: 3
    },
    {
      name: 'Species',
      selector: row => row.speciesId === 1 ? 'Canine' : 'Feline',
    },
    {
      name: 'Actions',
      center: true,
      cell: (row: ProactivePrescriptionRuleModel) => (
        !currentOverrideHospitalProactivePrescriptions
          ? <ActionButton
            iconclass="petco-view"
            text="View"
            onClick={() => moveToRuleDetails(row.proactivePrescriptionRuleId)}
          />
          : <i className="cursor-pointer fa fa-pencil" onClick={() => moveToRuleDetails(row.proactivePrescriptionRuleId)} />
      )
    },
  ]

    return (
        <>
            <Row className='d-flex flex-column'>
                <div className={`d-flex flex-row`}>
                    <Form.Label className="mb-0 mt-3 me-2 p-0">Allow Proactive Prescribing:</Form.Label>
                    <ToggleButton {...register("optOutOfProactivePrescription")} defaultChecked={optOutOfProactivePrescription} noSlider={!isEditing} />
                </div>
                <div className={`d-flex flex-row`}>
                    <Form.Label className="mb-0 mt-3 me-2 p-0">Allow Suggested Medications:</Form.Label>
                    <ToggleButton {...register("overrideHospitalProactivePrescriptions")} defaultChecked={overrideHospitalProactivePrescriptions} noSlider={!isEditing} />
                </div>
            </Row>
            {currentOverrideHospitalProactivePrescriptions && <div className="mt-3">
                <p className="text-danger">
                    <b>Note: </b>You&apos;ve opted out of using suggested medications. Proactive Prescribing remains active, but you must set your own medication preferences <b>per rule and species</b> for it to work. If no preference is set, <b>PetPass will not proactively prescribe</b> for that scenario.
                </p>
            </div>}
            <DataTable
                columns={columns}
                data={proactiveRxStore.proactivePrescriptionRules}
                customStyles={dataTableCustomStyles}
                onRowClicked={(row: ProactivePrescriptionRuleModel) => moveToRuleDetails(row.proactivePrescriptionRuleId)}            />
        </>
    )
})
